import React, { useEffect, useMemo, useRef } from "react";
// import { Button, Tabs } from "antd";
import styles from "./index.module.scss";
import ActivityItem, { PointsActivityItem } from "./components/PointsActivity";
import DesktopPointsActivity from "./components/DesktopPointsActivity";
import { useRequest } from "ahooks";
import { memberRequest } from "../../utils";
import { getAllPointsListApi } from "../../urls";
import { isMobile } from "react-device-detect";
import { useBottomShadow } from "./useBottomShadow";

const PointsActivities = React.forwardRef<
  HTMLDivElement,
  { customerId: number }
>(({ customerId }, ref) => {
  const scrollBoxRef = useRef(null);
  const { run: fetchAllPointsList, data: allPointsListData } = useRequest(
    async ({ memberId }: { memberId: number }) => {
      const params = {
        customer_id: memberId,
        current_page: 1,
        page_size: 10000,
      };

      return memberRequest({
        url: getAllPointsListApi,
        method: "GET",
        params,
      });
    }
  );

  const allPointsList = useMemo(() => {
    return allPointsListData?.data?.data?.total_list || [];
  }, [allPointsListData]);

  const { handleScrollBottom, reachBottom } = useBottomShadow(
    scrollBoxRef,
    allPointsListData
  );

  const activeTips = useMemo(() => {
    return (
      <div className={styles.noticeText}>
        *Points will be available when your order is delivered.
      </div>
    );
  }, []);

  const Empty = () => {
    return (
      <div className={styles.empty}>
        <p>No points yet—shop to start earning!</p>
      </div>
    );
  };

  useEffect(() => {
    fetchAllPointsList({ memberId: customerId });
  }, [fetchAllPointsList, customerId]);

  return (
    <div
      ref={ref}
      className={`${styles.pointsActivities} ${
        !isMobile ? styles.desktop : ""
      } ${reachBottom ? styles.hiddenBottomShadow : ""}`}
    >
      <div
        className={styles.content}
        onScroll={handleScrollBottom}
        ref={scrollBoxRef}
      >
        {!isMobile ? (
          <DesktopPointsActivity
            activities={allPointsList}
            emptyComponent={<Empty />}
          />
        ) : (
          <div>
            {allPointsList.length > 0 ? activeTips : null}
            <div className={styles.activitiesList}>
              {allPointsList.length > 0 ? (
                allPointsList.map(
                  (activity: PointsActivityItem, idx: number) => (
                    <ActivityItem key={idx} activity={activity} />
                  )
                )
              ) : (
                <Empty />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default PointsActivities;
